import {graphql} from 'react-relay';

export const sprintsPredictionsQuery = graphql`
	query ProjectSprintsPredictionsQuery($projectId: String, $groupId: String) {
		viewer {
			id
			component(name: "sprint_predictions")
			company {
				availableMLModels {
					lowHighModel
					lowHighModelScore
				}
			}
			project(id: $projectId) {
				id
				tasks(first: 100000, simpleResponse: true) @connection(key: "Project_tasks", filters: []) {
					edges {
						node {
							id
							predictedEstimate {
								estimate
								overrunProbability
							}
						}
					}
				}
			}
			projectGroup(id: $groupId) {
				projects(first: 1000000) {
					edges {
						node {
							tasks(first: 100000, approvedOnly: true, simpleResponse: true) @connection(key: "Project_tasks", filters: []) {
								edges {
									node {
										id
										predictedEstimate {
											estimate
											overrunProbability
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;
